<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset }" ref="observer">
    <artisio-modal size="md" :visible="modal.show" :data="model" scrollable
                   :title="$t(`Generate Police Book Report`)" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :scrollable="false" :is-loading="loading">

      <div class="d-flex justify-content-center align-items-center">
        <div class="col-md-8">
          <input-widget :model="model" attribute="police_book_date_range" type="daterangepicker"/>
        </div>
      </div>
      <div class="row mt-2 mb-2 d-flex justify-content-center align-items-center">
        <div class="col-md-auto">
          <input-widget is-switch :model="model" attribute="precious_metals" type="checkbox"/>
        </div>
        <div class="col-md-auto">
          <input-widget is-switch :model="model" attribute="firearms" type="checkbox"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
import InputWidget from "../../core/components/input-widget/InputWidget";
import {createNamespacedHelpers} from "vuex";
import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
import PoliceBookReportModel from "@/modules/police-books/PoliceBookModel.model";
import {WS_POLICE_BOOK_PROGRESS} from "@/modules/constants";
import PoliceBookService from "@/modules/police-books/PoliceBookService";

const {mapState, mapActions} = createNamespacedHelpers('policeBooks');
const {mapActions: mapActionsGlobal} = createNamespacedHelpers('global');

export default {
  name: "PoliceBookGenerationModal",
  components: {InputWidget, ArtisioModal},
  data() {
    return {
      loading: false,
      showConfirmation: true,
      model: new PoliceBookReportModel(),
      progress: null,
    }
  },
  computed: {
    ...mapState({
      modal: state => state.modal
    }),
  },

  methods: {
    ...mapActions(['hideModal', 'getTableData']),
    ...mapActionsGlobal(['addProgress', 'removeProgress', 'updateProgressValue']),
    onShow() {
      this.showConfirmation = true
    },
    onHidden() {
      this.model = new PoliceBookReportModel();
      this.hideModal();
      this.errorMessage = null;
      this.$refs.observer.reset();
    },
    async onSubmit() {
      this.loading = true;

      let payload = {
        report_date_range: this.model['police_book_date_range'],
        ...this.model.toJSON()
      }
      const response = await PoliceBookService.generatePoliceBookReport(payload);
      this.loading = false;

      if (response.success) {
        this.showConfirmation = false;
        this.hideModal();
        this.$toast('success', this.$i18n.t('Please wait until report is ready.'))
      } else if (response.body.non_field_errors) {
        this.$errorDialog(response.body.non_field_errors[0]);
      }
    },
    async addProgressIfNotExist() {
      if (!this.progress) {
        this.progress = await this.addProgress(this.$i18n.t("Generating police book report"));
      }
    },
    removeProgressIfExist() {
      if (this.progress) {
        this.removeProgress(this.progress.uuid)
        this.progress = null;
      }
    },
    async onProgressNotificationReceive(data) {
      await this.addProgressIfNotExist()
      this.updateProgressValue({
        progressValue: parseInt(Math.round(data.successful / data.total * 100)),
        uuid: this.progress.uuid
      });

      if (data.is_finished) {
        if (!data.errors) {
          this.$toast('success', this.$i18n.t("Police book generation has successfully finished"));
          this.getTableData()
        }
        this.removeProgressIfExist();
      }
      if (data.errors) {
        this.$errorDialog(this.$i18n.t(data.errors))
      }
    },
  },
  mounted() {
    this.$ws.listen(`inventories.${WS_POLICE_BOOK_PROGRESS}`, this.onProgressNotificationReceive);
  },
  beforeDestroy() {
    this.removeProgressIfExist();
    this.$ws.remove(`inventories.${WS_POLICE_BOOK_PROGRESS}`);
  }
}
</script>
